/**
 * social-proof/formatters.ts — pure, non-Intl number formatters for the
 * light big-stats band (R4-P3 masterplan §2.3, [AMENDED per C5]).
 *
 * MOVED verbatim from the now-deleted `SocialProofMotionController.tsx`
 * (Dec 1's rule: "Do not call Intl.NumberFormat(), Date.now(), or
 * toLocaleString() in the initial render" — kept non-Intl everywhere so a
 * mid-session locale toggle can never diverge from server-rendered digits
 * for the SAME snapshot). No React, no DOM, no client-only import — safe to
 * import from both the RSC `SocialProofSection` render path and the client
 * `BigStat`/`BigStatsMotion` motion layer.
 */

import type { Locale } from '../../hooks/useLocale';

export function formatMetricCount(value: number, locale: Locale): string {
  const rounded = Math.round(value);
  const sign = rounded < 0 ? '-' : '';
  const digits = Math.abs(rounded).toString();
  const groups: string[] = [];
  for (let end = digits.length; end > 0; end -= 3) {
    groups.unshift(digits.slice(Math.max(0, end - 3), end));
  }
  const separator = locale === 'ro' ? '.' : ',';
  return sign + groups.join(separator);
}

export function formatMetricRate(value: number, locale: Locale): string {
  const clamped = Math.min(100, Math.max(0, value));
  const parts = clamped.toFixed(1).split('.');
  const intPart = parts[0];
  const decPart = parts[1] ?? '0';
  const separator = locale === 'ro' ? ',' : '.';
  return `${intPart}${separator}${decPart}%`;
}
